import { useContext } from 'react';
import { FlowScreen, ScreenAttributes, ScreenType } from 'core/flow/entities';
import { useFunnelData } from 'core/funnel/contexts';
import { QuizContext } from 'core/funnel/contexts/FlowContext';

export const useNextScreensAttributes = (nextScreenId: string) => {
  const funnel = useFunnelData();
  const { getScreenAttributes } = useContext(QuizContext);

  const nextAttributes = getScreenAttributes(nextScreenId);

  if (nextAttributes.screenType !== ScreenType.SPLIT) {
    return [nextAttributes];
  }

  const nextScreensBySplit = funnel.flow?.screens?.find(
    (screen: FlowScreen) => screen.id === nextScreenId,
  );

  const nextAttributesBySplit = nextScreensBySplit?.attributes?.flatMap(
    (screen: { next: string }) => {
      const screenAttrs = getScreenAttributes(screen.next);

      return screenAttrs ? [screenAttrs] : [];
    },
  );

  return nextAttributesBySplit as ScreenAttributes[];
};
